import './Agenda.scss';
import useAgendaVM from './useAgendaVM';
import { Loader } from 'components/Loader/Loader';

export type AgendaPageProps = {};

export const Agenda: React.FC<AgendaPageProps> = () => {
    const { events, futureEvent, formatDate, formatHour, selectedEvent, setSelectedEvent, isApiRequestLoading } = useAgendaVM();

    if (isApiRequestLoading) {
        return (
            <main id="agenda">
                <Loader />
            </main>
        );
    }

    return (
        <>
            <main id="agenda">
                <div className="appointments">
                    <div className="next-appointment">
                        <h2>Mon prochain rendez-vous</h2>
                        {futureEvent ? (
                            <div
                                className={`appointment ${selectedEvent?.id === futureEvent?.id ? 'selected' : ''}`}
                                onClick={() => setSelectedEvent(futureEvent || null)}
                            >
                                <h4>{futureEvent.label}</h4>
                                <p>Le {formatDate(futureEvent.started_at || '')}</p>
                            </div>
                        ) : (
                            <p className="no-appointment">Aucun rendez-vous prévu</p>
                        )}
                    </div>
                    <div className="previous-appointments">
                        <h2>Rendez-vous précédents</h2>
                        <div className="previous-appointments-content">
                            {events.map((event, index) => {
                                return (
                                    <div
                                        className={`appointment ${selectedEvent?.id === event.id ? 'selected' : ''}`}
                                        key={index}
                                        onClick={() => setSelectedEvent(event)}
                                    >
                                        <h4>{event.label}</h4>
                                        <p>Le {formatDate(event.started_at || '')}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="selected-appointment">
                    {selectedEvent ? (
                        <>
                            <h2>Préparation à l'entretien</h2>
                            {selectedEvent.observation && <p>{selectedEvent.observation}</p>}
                            <div className="appointment-infos">
                                {selectedEvent.started_at && selectedEvent.ended_at && (
                                    <>
                                        <div className="appointment-info date">
                                            <h3>Date :</h3>
                                            <p>Le {formatDate(selectedEvent.started_at || '')}</p>
                                        </div>
                                        <div className="appointment-info time">
                                            <h3>Heure :</h3>
                                            <p>
                                                De {formatHour(selectedEvent.started_at || '')} à {formatHour(selectedEvent.ended_at || '')}
                                            </p>
                                        </div>
                                    </>
                                )}
                                {selectedEvent.address && selectedEvent.address.formatted && selectedEvent.address.formatted.length > 0 ? (
                                    <div className="appointment-info place">
                                        <div className="place-infos">
                                            <h3>Lieu :</h3>
                                            <p>{selectedEvent.address.formatted}</p>
                                        </div>
                                        <div className="place-extra-infos">
                                            <a
                                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${selectedEvent.address.formatted}`)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Visualiser le lieu de rendez-vous sur la carte
                                            </a>
                                            <iframe
                                                width="600"
                                                height="400"
                                                style={{ border: 0, marginTop: '1rem' }}
                                                loading="lazy"
                                                allowFullScreen
                                                src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&zoom=16&q=${encodeURIComponent(`${selectedEvent.address.formatted}`)}`}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="appointment-info place">
                                        <div className="place-infos">
                                            <h3>Type de rendez-vous :</h3>
                                            <p>À distance (Téléphone ou vidéo)</p>
                                        </div>
                                    </div>
                                )}
                                {(selectedEvent.assistants_list && selectedEvent.assistants_list.length > 0) ||
                                    (selectedEvent.stakeholders_list && selectedEvent.stakeholders_list.length > 0 && (
                                        <div className="appointment-info persons">
                                            <h3>Personnes présentes</h3>
                                            <div className="persons-list">
                                                {selectedEvent.assistants_list &&
                                                    selectedEvent.assistants_list.map((assistant) => (
                                                        <p key={assistant.value}>{assistant.label}</p>
                                                    ))}
                                                {selectedEvent.stakeholders_list &&
                                                    selectedEvent.stakeholders_list.map((stakeholder) => (
                                                        <p key={stakeholder.value}>{stakeholder.label}</p>
                                                    ))}
                                                {selectedEvent.partners_list &&
                                                    selectedEvent.partners_list.length > 0 &&
                                                    selectedEvent.partners_list.map((partner) => (
                                                        <p key={partner.value}>{partner.label}</p>
                                                    ))}
                                                {!selectedEvent.assistants_list?.length &&
                                                    !selectedEvent.stakeholders_list?.length &&
                                                    !selectedEvent.partners_list?.length && <p>Aucune personne présente</p>}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </>
                    ) : (
                        <h2>Aucun rendez-vous sélectionné</h2>
                    )}
                </div>
            </main>
        </>
    );
};
